// Desain Bordir: kartu Performa Hari Ini (ringkas) + panel lengkap yang bisa dibuka (default tertutup).
import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { ProduktivitasHarianChart } from "./produktivitas_harian_chart";
import { useAutoRefresh } from "./use_auto_refresh";
import "./press_hub.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function DesainTodayCard({ operator, late = 0, near = 0 }) {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);
  const [open, setOpen] = useState(false);
  const load = useCallback(async () => {
    try {
      const l = await axios.get(`${API}/shopee/embroidery/leaderboard`, { params: { scope: "all", days: 1 }, withCredentials: true, timeout: 20000 });
      const ds = l.data?.designers || [];
      const first = (s) => String(s || "").trim().toLowerCase().split(/\s+/)[0];
      const me = ds.find(x => x.id === operator?.id) || ds.find(x => first(x.name) && first(x.name) === first(operator?.name));
      setD({ done: me?.total ?? 0, rank: me?.rank || null, total: ds.filter(x => x.rank).length });
      setErr(false);
    } catch { setErr(true); }
  }, [operator?.id, operator?.name]);
  useEffect(() => { load(); }, [load]);
  useAutoRefresh({ enabled: true, intervalMs: 60_000, onRefresh: load });
  return <section className="dtc" data-testid="desain-today-card">
    <div className="dtc-row">
      <div className="dtc-kpi" data-testid="desain-today-done"><b>{d && typeof d.done === "number" ? d.done : "…"}</b><span>Desain selesai hari ini</span></div>
      <div className="dtc-kpi" data-testid="desain-today-rank"><b>{d?.rank ? `#${d.rank}` : "–"}</b><span>{d?.rank ? `Peringkat hari ini dari ${d.total}` : "Belum ada desain selesai hari ini"}</span></div>
      {(late > 0 || near > 0) && <div className="dtc-dl" data-testid="desain-today-deadline">
        {late > 0 && <span className="late">Terlambat {late}</span>}{near > 0 && <span className="near">Hampir deadline {near}</span>}</div>}
      <button type="button" className="phub-chip dtc-btn" onClick={() => setOpen(v => !v)} aria-expanded={open} data-testid="desain-today-toggle">
        {open ? "Tutup Detail" : "Lihat Detail"}</button>
    </div>
    {err && <div className="muted small" data-testid="desain-today-error">Koneksi bermasalah — angka performa belum bisa dimuat.</div>}
    {open && <div className="dtc-full" data-testid="desain-today-full"><ProduktivitasHarianChart scopeTab="all" testIdPrefix="bordir-offline-produktivitas"/></div>}
  </section>;
}
